import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <header className="header">
      <div className="container header-container">
        <Link to="/" className="logo" onClick={closeMenu}>
          <div className="logo-icon">
            <span className="material-symbols-outlined">visibility</span>
          </div>
          <span className="logo-text">CataractLensAdvisor</span>
        </Link>

        <button className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Toggle navigation">
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li className={`nav-item ${isActive('/')}`}>
              <Link to="/" onClick={closeMenu}>How It Works</Link>
            </li>
            <li className={`nav-item ${isActive('/cataract-lens-types')}`}>
              <Link to="/cataract-lens-types" onClick={closeMenu}>Lens Guide</Link>
            </li>
            <li className={`nav-item ${isActive('/cataract-surgery-faq')}`}>
              <Link to="/cataract-surgery-faq" onClick={closeMenu}>FAQs</Link>
            </li>
            <li className="nav-item cta-item">
              <Link to="/cataract-lens-questionnaire" className="btn btn-primary" onClick={closeMenu}>
                Start Assessment
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
